import { APIEndpoints } from "@/utils/APIEndpoints";
import { riccAPI } from "./APIService";

riccAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Search Operator using Operator ID
    searchOperatorForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.searchOperatorForAdmin,
        method: "POST",
        body: payload,
      }),
    }),
    // Approve or Reject Access Rules
    approveOrRejectAccessForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.approveOrRejectAccessForAdmin,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["approveProfile"],
    }),

    // Get Audit History
    getAccessRuleAuditHistoryForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getAccessRuleAuditHistoryForAdmin,
        method: "POST",
        body: payload,
      }),
    }),
    // Update Operator Details
    updateOperatorFromAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.updateOperatorFromAdmin,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["updateOperator"],
    }),

    // Get Record Keeping System
    getRecordKeepingSystem: builder.query({
      query: () => APIEndpoints.recordKeepingSystem,
      providesTags: ["recordKeeper"],
    }),
    // Save New Record Keeping System
    saveRecordKeepingSystem: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.recordKeepingSystem,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["recordKeeper"],
    }),
    // Update New Record Keeping System
    updateRecordKeepingSystem: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.recordKeepingSystem,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["recordKeeper"],
    }),

    // Get Record Keeping System Contact
    getRecordKeepingSystemContact: builder.query({
      query: ({ recordKeeperId }) => ({
        url: APIEndpoints.recordKeepingSystemContact,
        method: "GET",
        params: {
          recordKeeperId: recordKeeperId,
        },
      }),
      providesTags: ["recordKeeperContact"],
    }),
    // Delete Record Keeping System Contact
    deleteRecordKeepingSystemContact: builder.mutation({
      query: ({ contactId, recordKeeperId }) => ({
        url: APIEndpoints.recordKeepingSystemContact,
        method: "DELETE",
        params: {
          contactId: contactId,
          recordKeeperId: recordKeeperId,
        },
      }),
      invalidatesTags: ["recordKeeperContact"],
    }),
    // Save New Record Keeping System Contact
    saveRecordKeepingSystemContact: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.recordKeepingSystemContact,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["recordKeeperContact"],
    }),
    // Update New Record Keeping System Contact
    updateRecordKeepingSystemContact: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.recordKeepingSystemContact,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["recordKeeperContact"],
    }),

    // Get Product Manufacturers
    getProductManufacturerForAdmin: builder.query({
      query: () => APIEndpoints.productManufacturersForAdmin,
      providesTags: ["productManufacturer"],
    }),
    // Save New Product Manufacturer
    saveProductManufacturerForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturersForAdmin,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productManufacturer"],
    }),
    // Update Product Manufacturer
    updateProductManufacturerForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturersForAdmin,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["productManufacturer"],
    }),

    // Get Product Manufacturer Contact
    getProductManufacturerContact: builder.query({
      query: ({ productSponsorId }) => ({
        url: APIEndpoints.productManufacturerContact,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
      providesTags: ["productManufacturerContact"],
    }),
    // Save Product Manufacturer Contact
    saveProductManufacturerContactForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturerContact,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productManufacturerContact"],
    }),
    // Update Product Manufacturer Contact
    updateProductManufacturerContactForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturerContact,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["productManufacturerContact"],
    }),
    // Delete Product Manufacturer Contact
    deleteProductManufacturerContactForAdmin: builder.mutation({
      query: ({ contactId, productSponsorId }) => ({
        url: APIEndpoints.productManufacturerContact,
        method: "DELETE",
        params: {
          contactId: contactId,
          productSponsorId: productSponsorId,
        },
      }),
      invalidatesTags: ["productManufacturerContact"],
    }),

    // Get Product Manufacturer Insurance Companies
    getProductManufacturerInsuranceCompanies: builder.query({
      query: ({ productSponsorId }) => ({
        url: APIEndpoints.productManufacturerInsuranceCompanies,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
      providesTags: ["productManufacturerInsurances"],
    }),
    // Save/Update Product Manufacturer Insurance Companies
    saveProductManufacturerInsuranceCompanies: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturerInsuranceCompanies,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productManufacturerInsurances", "productManufacturer"],
    }),

    // Get Product Manufacturer Investment Vehicles
    getProductManufacturerInvestmentVehicles: builder.query({
      query: ({ productSponsorId }) => ({
        url: APIEndpoints.productManufacturerInvestmentVehicles,
        method: "GET",
        params: {
          productSponsorId: productSponsorId,
        },
      }),
      providesTags: ["productManufacturerVehicles"],
    }),
    // Save/Update Product Manufacturer Investment Vehicles
    saveProductManufacturerInvestmentVehicles: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.productManufacturerInvestmentVehicles,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["productManufacturerVehicles", "productManufacturer"],
    }),

    // Get ALL Management Companies
    getManagementCompanies: builder.query({
      query: () => APIEndpoints.managementCompanies,
      providesTags: ["managementCompanies"],
    }),
    // Save Management Companies
    saveManagementCompanies: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.managementCompanies,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["managementCompanies"],
    }),
    // Update Management Companies
    updateManagementCompanies: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.managementCompanies,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["managementCompanies"],
    }),

    // Get Investment Vehicles
    getInvestmentVehicles: builder.query({
      query: (investmentMgmtCompanyId) => ({
        url: APIEndpoints.investmentVehicles,
        method: "GET",
        params: {
          investmentMgmtCompanyId: investmentMgmtCompanyId,
        },
      }),
      providesTags: ["investmentVehicles"],
    }),
    // Get Investment Vehicles
    getProductInvestmentVehicles: builder.query({
      query: (id) => ({
        url: APIEndpoints.productAdminInvestmentVehicles,
        method: "GET",
        params: {
          id: id,
        },
      }),
    }),
    // Save Investment Vehicles
    saveInvestmentVehicles: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.investmentVehicles,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["investmentVehicles"],
    }),
    // Update Investment Vehicles
    updateInvestmentVehicles: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.investmentVehicles,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["investmentVehicles"],
    }),
    // Get Investment Vehicles Audit Transaction
    getInvestmentVehiclesAudit: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.investmentVehiclesAudit,
        method: "POST",
        body: payload,
      }),
    }),

    // Get ALL Insurance Companies
    getInsuranceCompaniesForAdmin: builder.query({
      query: () => ({
        url: APIEndpoints.getInsuranceCompaniesForEnrollment,
        method: "GET",
      }),
      providesTags: ["insuranceCompany"],
    }),
    // Save New Insurance Company
    saveInsuranceCompanyForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.insuranceCompany,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["insuranceCompany"],
    }),
    // Update Insurance Company
    updateInsuranceCompanyForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.insuranceCompany,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["insuranceCompany"],
    }),

    // Get Insurance Company Contact
    getInsuranceCompanyContact: builder.query({
      query: ({ insuranceCompanyId }) => ({
        url: APIEndpoints.insuranceCompanyContact,
        method: "GET",
        params: {
          insuranceCompanyId: insuranceCompanyId,
        },
      }),
      providesTags: ["insuranceCompanyContact"],
    }),
    // Save Insurance Company Contact
    saveInsuranceCompanyContactForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.insuranceCompanyContact,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["insuranceCompanyContact"],
    }),
    // Update Insurance Company Contact
    updateInsuranceCompanyContactForAdmin: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.insuranceCompanyContact,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["insuranceCompanyContact"],
    }),
    // Delete Insurance Company Contact
    deleteInsuranceCompanyContactForAdmin: builder.mutation({
      query: ({ contactId, insuranceId }) => ({
        url: APIEndpoints.insuranceCompanyContact,
        method: "DELETE",
        params: {
          contactId: contactId,
          insuranceCompanyId: insuranceId,
        },
      }),
      invalidatesTags: ["insuranceCompanyContact"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchOperatorForAdminMutation,
  useApproveOrRejectAccessForAdminMutation,
  useGetAccessRuleAuditHistoryForAdminMutation,
  useUpdateOperatorFromAdminMutation,

  useGetRecordKeepingSystemQuery,
  useSaveRecordKeepingSystemMutation,
  useUpdateRecordKeepingSystemMutation,

  useGetRecordKeepingSystemContactQuery,
  useDeleteRecordKeepingSystemContactMutation,
  useSaveRecordKeepingSystemContactMutation,
  useUpdateRecordKeepingSystemContactMutation,

  useGetProductManufacturerForAdminQuery,
  useSaveProductManufacturerForAdminMutation,
  useUpdateProductManufacturerForAdminMutation,

  useGetProductManufacturerContactQuery,
  useSaveProductManufacturerContactForAdminMutation,
  useUpdateProductManufacturerContactForAdminMutation,
  useDeleteProductManufacturerContactForAdminMutation,

  useGetProductManufacturerInsuranceCompaniesQuery,
  useSaveProductManufacturerInsuranceCompaniesMutation,

  useGetProductManufacturerInvestmentVehiclesQuery,
  useSaveProductManufacturerInvestmentVehiclesMutation,

  useGetManagementCompaniesQuery,
  useSaveManagementCompaniesMutation,
  useUpdateManagementCompaniesMutation,

  useGetInvestmentVehiclesQuery,
  useGetProductInvestmentVehiclesQuery,
  useSaveInvestmentVehiclesMutation,
  useUpdateInvestmentVehiclesMutation,
  useGetInvestmentVehiclesAuditMutation,

  useGetInsuranceCompaniesForAdminQuery,
  useSaveInsuranceCompanyForAdminMutation,
  useUpdateInsuranceCompanyForAdminMutation,

  useGetInsuranceCompanyContactQuery,
  useSaveInsuranceCompanyContactForAdminMutation,
  useUpdateInsuranceCompanyContactForAdminMutation,
  useDeleteInsuranceCompanyContactForAdminMutation,
} = riccAPI;
